// extracted by mini-css-extract-plugin
module.exports = {"container":"SetupSecurity_container__3H8Dw","row":"SetupSecurity_row__MdE5d"};